import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import SLPSignup from './pages/SLPSignup';
import SLPLogin from './pages/SLPLogin';
import TeacherLogin from './pages/TeacherLogin';
import Dashboard from './pages/Dashboard';
import ScreeningWizard from './pages/ScreeningWizard';
import ResultsPage from './pages/ResultsPage';
import SettingsPage from './pages/SettingsPage';
import FeedbackBoard from './pages/FeedbackBoard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { Toaster } from './components/ui/sonner';
import './App.css';

axios.defaults.withCredentials = true;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    // Try SLP session first
    try {
      const res = await axios.get(`/api/slp/session`, { withCredentials: true });
      setIsAuthenticated(true);
      setUserData(res.data);
      setLoading(false);
      return;
    } catch (e) { /* not SLP */ }
    // Try teacher session
    try {
      const res = await axios.get(`/api/teacher/session`, { withCredentials: true });
      setIsAuthenticated(true);
      setUserData(res.data);
      setLoading(false);
      return;
    } catch (e) { /* not teacher */ }
    setIsAuthenticated(false);
    setUserData(null);
    setLoading(false);
  };

  const handleLogin = (data) => {
    setIsAuthenticated(true);
    setUserData(data);
  };

  const handleLogout = async () => {
    try {
      if (userData?.user_type === 'teacher') {
        await axios.post(`/api/teacher/logout`, {}, { withCredentials: true });
      } else {
        await axios.post(`/api/slp/logout`, {}, { withCredentials: true });
      }
    } catch (e) { console.error('Logout error:', e); }
    setIsAuthenticated(false);
    setUserData(null);
  };

  if (loading) {
    return (
      <div className="App min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--fe-bg)' }}>
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-[#2C4C3B] border-t-transparent rounded-full animate-spin" />
          <p className="mt-4 text-[#595959]">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
          <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <TeacherLogin onLogin={handleLogin} />} />
          <Route path="/slp/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <SLPLogin onLogin={handleLogin} />} />
          <Route path="/slp/signup" element={isAuthenticated ? <Navigate to="/dashboard" /> : <SLPSignup />} />
          <Route path="/forgot-password" element={isAuthenticated ? <Navigate to="/dashboard" /> : <ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={isAuthenticated ? <Dashboard userData={userData} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/screening" element={isAuthenticated ? <ScreeningWizard userData={userData} /> : <Navigate to="/login" />} />
          <Route path="/results/:id" element={isAuthenticated ? <ResultsPage userData={userData} /> : <Navigate to="/login" />} />
          <Route path="/settings" element={isAuthenticated && userData?.user_type === 'slp' ? <SettingsPage slpData={userData} /> : <Navigate to="/login" />} />
          <Route path="/feedback" element={isAuthenticated ? <FeedbackBoard slpData={userData} /> : <Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
